import Layout from "layouts";
import React from "react";
import Dashboard from "./Dashboard";

export default function Home() {
  return (
    <Layout noHeader>
      <Dashboard />
    </Layout>
  );
}
